function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    &:not(:empty) {\n      margin-right: 8px;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      width: ", ";      \n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import { EnumProductStates, EnumButtonSize } from "../types";
import Button from "../../Button";
import QuantityControls from "../../QuantityControls";
import Cart from "../../Icon/Cart";
import { hideAfterSm, hideBeforeSm, mediaSmUp, mediaSmDown } from "../../../theme/helpers/media";
import Flex from "../../Grid/Flex";
import colors from "../../../colors";
import { PRODUCT_ADD_BUTTON_TEST_ID, PRODUCT_BACK_IN_CART_BUTTON_TEST_ID, PRODUCT_CHANGE_BUTTON_TEST_ID } from "../constants";
import OrderControls from "./OrderControls";
import { defaultTheme as quantityControlsTheme } from "../../QuantityControls/theme";
// FIXME: временное решение с quantityControlsTheme
var Wrapper = styled.div.withConfig({
  displayName: "ListControls__Wrapper",
  componentId: "fa7vkf-0"
})(["", " ", ""], function (_ref) {
  var size = _ref.size;
  return css(["", ""], mediaSmUp(_templateObject(), quantityControlsTheme.size[size]));
}, mediaSmDown(_templateObject2()));
export var ButtonStyled = styled(Button).withConfig({
  displayName: "ListControls__ButtonStyled",
  componentId: "fa7vkf-1"
})(["flex-shrink:0;", ";"], function (_ref2) {
  var isKomus = _ref2.isKomus;

  if (isKomus) {
    return css(["line-height:16px !important;font-size:14px !important;font-weight:normal;background-color:", ";color:", " !important;&:hover,&:active,&:focus{background-color:", ";color:", " !important;border:1px solid ", ";}"], colors.light200, colors.primaryMain, colors.light200, colors.primaryMain, colors.primaryMain);
  }
});
export var DesktopButtonsWrapper = styled.div.withConfig({
  displayName: "ListControls__DesktopButtonsWrapper",
  componentId: "fa7vkf-2"
})(["", ";& ", " + ", "{margin-top:8px;}"], hideBeforeSm, ButtonStyled, ButtonStyled);
var MobileButtonsWrapper = styled(Flex).withConfig({
  displayName: "ListControls__MobileButtonsWrapper",
  componentId: "fa7vkf-3"
})(["", ";"], hideAfterSm);

var ListControls = function ListControls(_ref3) {
  var _EnumProductStates$to;

  var state = _ref3.state,
      onAddToCart = _ref3.onAddToCart,
      onAddToOrder = _ref3.onAddToOrder,
      onQuantityChange = _ref3.onQuantityChange,
      canAddToOrder = _ref3.canAddToOrder,
      quantity = _ref3.quantity,
      showWeight = _ref3.showWeight,
      weight = _ref3.weight,
      className = _ref3.className,
      isMobileControlsVisible = _ref3.isMobileControlsVisible,
      toggleMobileControls = _ref3.toggleMobileControls,
      onReplace = _ref3.onReplace,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? EnumButtonSize.normal : _ref3$size,
      onReturn = _ref3.onReturn,
      isKomus = _ref3.isKomus;

  var _useContext = useContext(ThemeContext),
      addToBasketText = _useContext.addToBasketText;

  return React.createElement(Wrapper, {
    className: className,
    size: size
  }, (_EnumProductStates$to = {}, _defineProperty(_EnumProductStates$to, EnumProductStates.toBasket, React.createElement(React.Fragment, null, React.createElement(DesktopButtonsWrapper, null, canAddToOrder && !isMobileControlsVisible ? React.createElement(OrderControls, {
    isMobileControlsVisible: true,
    toggleMobileControls: toggleMobileControls,
    onAddToCart: onAddToCart,
    onAddToOrder: onAddToOrder,
    size: size,
    isKomus: isKomus
  }) : React.createElement(ButtonStyled, {
    "data-testid": PRODUCT_ADD_BUTTON_TEST_ID,
    size: size,
    fluid: true,
    onClick: onAddToCart,
    isKomus: isKomus
  }, addToBasketText)), React.createElement(MobileButtonsWrapper, null, canAddToOrder ? React.createElement(OrderControls, {
    isMobileControlsVisible: isMobileControlsVisible,
    toggleMobileControls: toggleMobileControls,
    onAddToCart: onAddToCart,
    onAddToOrder: onAddToOrder,
    size: size,
    isKomus: isKomus
  }) : React.createElement(ButtonStyled, {
    "data-testid": PRODUCT_ADD_BUTTON_TEST_ID,
    size: size,
    icon: true,
    onClick: onAddToCart,
    isKomus: isKomus
  }, isKomus ? React.createElement(Cart, {
    color: colors.primaryMain
  }) : React.createElement(Cart, null))))), _defineProperty(_EnumProductStates$to, EnumProductStates.inBasket, onQuantityChange && React.createElement(QuantityControls, {
    weight: weight,
    quantity: quantity,
    onChange: onQuantityChange,
    showWeight: showWeight,
    isKomus: isKomus
  })), _defineProperty(_EnumProductStates$to, EnumProductStates.revert, React.createElement(Button, {
    "data-testid": PRODUCT_BACK_IN_CART_BUTTON_TEST_ID,
    size: size,
    fluid: true,
    onClick: onReturn
  }, "\u0412\u0435\u0440\u043D\u0443\u0442\u044C")), _defineProperty(_EnumProductStates$to, EnumProductStates.notAvailable, onReplace && React.createElement(ButtonStyled, {
    "data-testid": PRODUCT_CHANGE_BUTTON_TEST_ID,
    size: size,
    fluid: true,
    onClick: onReplace,
    isKomus: isKomus
  }, "\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C")), _EnumProductStates$to)[state]);
};

export default styled(ListControls).withConfig({
  displayName: "ListControls",
  componentId: "fa7vkf-4"
})([""]);